import React from "react";
import DashboardLayout from "../../layout/DashboardLayout";
import MainContent from "../../components/Jobs/MainContent";

const Jobs = () => {
  return (
    <DashboardLayout>
      <MainContent />
    </DashboardLayout>
  );
};

export default Jobs;
